var map = {
	"./Framabag.vue": 118,
	"./Framabee.vue": 116,
	"./Framabin.vue": 119,
	"./Framaboard.vue": 120,
	"./Framabookin.vue": 121,
	"./Framacalc.vue": 122,
	"./Framaclic.vue": 123,
	"./Framadrive.vue": 124,
	"./Framadrop.vue": 125,
	"./Framaestro.vue": 126,
	"./Framalink.vue": 127,
	"./Framanews.vue": 128,
	"./Framanotes.vue": 129,
	"./Framapack.vue": 130,
	"./Framapiaf.vue": 131,
	"./Framapic.vue": 132,
	"./Framasite.vue": 133,
	"./Framaslides.vue": 134,
	"./Framasphere.vue": 135,
	"./Framastory.vue": 136,
	"./Framavectoriel.vue": 137,
	"./Framawiki.vue": 138,
	"./Framemo.vue": 139,
	"./Framindmap.vue": 140,
	"./Framinetest.vue": 141,
	"./Home.vue": 117,
	"./Mumble.vue": 142,
	"./Myframa.vue": 143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;